export default __webpack_public_path__ + "static/media/testi-video.9f087251.png";